import type { FC, ReactNode } from 'react';
import { Text } from '@launchpad-ui/components';

import { CheckAnimation } from './CheckAnimation';
import { PulsingCircle } from './PulsingCircle';

import styles from './SdkSetupConnectionIndicator.module.css';

interface SdkSetupConnectionIndicatorProps {
  isActive: boolean;
  /** Override copy shown when the SDK is connected. */
  activeText?: ReactNode;
  /** Override copy shown while waiting for the SDK to connect. */
  inactiveText?: ReactNode;
  /** Optional secondary line shown below the main status line while inactive. */
  helperText?: ReactNode;
  /** Optional content below the status row, inside the same bordered container (e.g. actions). */
  footer?: ReactNode;
}

export const SdkSetupConnectionIndicator: FC<SdkSetupConnectionIndicatorProps> = ({
  isActive,
  activeText = "Connected! You're ready to build with LaunchDarkly.",
  inactiveText = 'Watching for your first event…',
  helperText,
  footer,
}) => {
  return (
    <div className={`${styles.container} ${isActive ? styles.active : ''}`}>
      <div className={styles.content}>
        {isActive ? <CheckAnimation /> : <PulsingCircle />}
        <div className={styles.textContainer}>
          <Text>{isActive ? activeText : inactiveText}</Text>
          {!isActive && helperText !== undefined && helperText !== null ? (
            <Text className={styles.helper}>{helperText}</Text>
          ) : null}
        </div>
      </div>
      {footer !== undefined && footer !== null ? <div className={styles.footer}>{footer}</div> : null}
    </div>
  );
};
